<template>
    <integration-log-code-card :data="props.entry.extracted_data">
        <template v-slot:title> Extracted Data </template>
        <template v-slot:subtitle> Normalized data extracted from the webhook payload. </template>
    </integration-log-code-card>
</template>

<script lang="ts" setup>
import IntegrationLogCodeCard from './IntegrationLogCodeCard.vue';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();
</script>
